import { createFileRoute } from "@tanstack/react-router";
import { useFeatureFlagEnabled } from "posthog-js/react";

import { WhatsAppForwardingContainer } from "@/features/settings/whatsapp-forwarding";

export const Route = createFileRoute(
  "/_authenticated/$company/unternehmen/_settings/einstellungen/whatsapp-weiterleitung",
)({
  component: WhatsAppForwardingPage,
});

function WhatsAppForwardingPage() {
  const whatsappIntegrationEnabled = useFeatureFlagEnabled(
    "whatsapp-integration",
  );

  if (!whatsappIntegrationEnabled) {
    return null;
  }

  return <WhatsAppForwardingContainer />;
}
